import { render, staticRenderFns } from "./productItemAdd.vue?vue&type=template&id=1459dd64&scoped=true&"
import script from "./productItemAdd.vue?vue&type=script&lang=js&"
export * from "./productItemAdd.vue?vue&type=script&lang=js&"
import style0 from "./productItemAdd.vue?vue&type=style&index=0&id=1459dd64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1459dd64",
  null
  
)

export default component.exports